import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MEDIA_TYPES, REACTIONS } from '../../constants';

const useActiv8Tabs = () => {
  const { t } = useTranslation('activ8');

  return useMemo(() => {
    return [
      {
        groupName: 'mediaType',
        title: t('mediaType'),
        placeholder: t('all'),
        options: [
          {
            value: MEDIA_TYPES.IMAGE,
            label: t('image'),
            isRadio: true,
          },
          {
            value: MEDIA_TYPES.VIDEO,
            label: t('video'),
            isRadio: true,
          },
        ],
      },
      {
        groupName: 'reaction',
        title: t('reaction'),
        placeholder: t('all'),
        options: [
          {
            value: REACTIONS.LIKE,
            label: t('liked'),
            isRadio: true,
          },
        ],
      },
    ];
  }, [t]);
};

export default useActiv8Tabs;
